<template>
	<header class="header" :class="{}">
		<div class="container header__container" :class="{'logged': userLoggedIn}">
			<a :href="mainSiteLink" style="display: flex" target="_blank" class="header__logo-link-sm">
				<img v-if="!userLoggedIn && !isTablet" class="header__logo-lg" src="https://incognitocr.ru/images/dest/logo-new.svg" alt="logo">
				<img v-else-if="!userLoggedIn || isTablet" class="header__logo-sm" src="https://incognitocr.ru/images/dest/logo-new.svg" alt="logo">
			</a>
			<template v-if="isTablet">
				<button v-if="userLoggedIn" @click="showMobileMenu = true" class="header__menu-btn" >
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="13" viewBox="0 0 24 13" fill="none">
						<rect width="24" height="3" rx="1.5" fill="#292927"/>
						<rect y="5" width="24" height="3" rx="1.5" fill="#292927"/>
						<rect y="10" width="19.2" height="3" rx="1.5" fill="#292927"/>
					</svg>
				</button>
				<button @click="store.commit('SET_CONTACT_METHODS', true)" class="header__incognito-connect">
					<img src="./img/contact.svg" alt=""/>
				</button>
				<div v-if="!userLoggedIn" style="display: flex; flex-direction: column; gap: 3px">
					<a :class="{'not-auth': !userLoggedIn}" class="header__phone" href="tel:+78006003624">8 (800) 600-36-24</a>
				</div>
			</template>
			<div class="header__desktop-right" v-else>
				<button @click="store.commit('SET_CONTACT_METHODS', true)" class="header__incognito-connect">
					<svg xmlns="http://www.w3.org/2000/svg" width="80" height="79" viewBox="0 0 80 79" fill="none">
						<g opacity="0.9">
							<circle cx="40" cy="39.4375" r="28" fill="#8CBD8F"/>
							<mask id="path-2-inside-1_2984_554" fill="white">
								<path d="M36.7741 6.06191C36.7276 5.5005 36.2346 5.08144 35.6748 5.14469C31.5818 5.60718 27.604 6.80994 23.9363 8.69712C19.9661 10.74 16.4372 13.5448 13.551 16.9515C10.6648 20.3582 8.4778 24.3 7.11496 28.5519C5.85598 32.4797 5.32308 36.6011 5.53931 40.7145C5.56888 41.277 6.06324 41.6945 6.62465 41.6481C7.18607 41.6016 7.60184 41.1089 7.57334 40.5463C7.37854 36.7 7.8804 32.8473 9.05761 29.1745C10.3387 25.1778 12.3944 21.4725 15.1075 18.2702C17.8205 15.0679 21.1377 12.4314 24.8697 10.5111C28.2991 8.74647 32.0171 7.61846 35.8431 7.17872C36.4027 7.1144 36.8205 6.62332 36.7741 6.06191Z"/>
							</mask>
							<path d="M36.7741 6.06191C36.7276 5.5005 36.2346 5.08144 35.6748 5.14469C31.5818 5.60718 27.604 6.80994 23.9363 8.69712C19.9661 10.74 16.4372 13.5448 13.551 16.9515C10.6648 20.3582 8.4778 24.3 7.11496 28.5519C5.85598 32.4797 5.32308 36.6011 5.53931 40.7145C5.56888 41.277 6.06324 41.6945 6.62465 41.6481C7.18607 41.6016 7.60184 41.1089 7.57334 40.5463C7.37854 36.7 7.8804 32.8473 9.05761 29.1745C10.3387 25.1778 12.3944 21.4725 15.1075 18.2702C17.8205 15.0679 21.1377 12.4314 24.8697 10.5111C28.2991 8.74647 32.0171 7.61846 35.8431 7.17872C36.4027 7.1144 36.8205 6.62332 36.7741 6.06191Z" stroke="#8CBD8F" stroke-width="4" mask="url(#path-2-inside-1_2984_554)"/>
							<mask id="path-3-inside-2_2984_554" fill="white">
								<path d="M43.2253 72.8142C43.2717 73.3756 43.7647 73.7947 44.3245 73.7314C48.4175 73.2689 52.3953 72.0662 56.063 70.179C60.0332 68.1361 63.5621 65.3313 66.4484 61.9246C69.3346 58.5179 71.5215 54.5761 72.8844 50.3242C74.1433 46.3964 74.6762 42.275 74.46 38.1616C74.4304 37.5991 73.9361 37.1816 73.3747 37.228C72.8133 37.2745 72.3975 37.7672 72.426 38.3298C72.6208 42.1761 72.1189 46.0288 70.9417 49.7016C69.6607 53.6983 67.6049 57.4036 64.8919 60.6059C62.1788 63.8082 58.8616 66.4447 55.1296 68.365C51.7002 70.1296 47.9822 71.2576 44.1562 71.6974C43.5966 71.7617 43.1788 72.2528 43.2253 72.8142Z"/>
							</mask>
							<path d="M43.2253 72.8142C43.2717 73.3756 43.7647 73.7947 44.3245 73.7314C48.4175 73.2689 52.3953 72.0662 56.063 70.179C60.0332 68.1361 63.5621 65.3313 66.4484 61.9246C69.3346 58.5179 71.5215 54.5761 72.8844 50.3242C74.1433 46.3964 74.6762 42.275 74.46 38.1616C74.4304 37.5991 73.9361 37.1816 73.3747 37.228C72.8133 37.2745 72.3975 37.7672 72.426 38.3298C72.6208 42.1761 72.1189 46.0288 70.9417 49.7016C69.6607 53.6983 67.6049 57.4036 64.8919 60.6059C62.1788 63.8082 58.8616 66.4447 55.1296 68.365C51.7002 70.1296 47.9822 71.2576 44.1562 71.6974C43.5966 71.7617 43.1788 72.2528 43.2253 72.8142Z" stroke="#8CBD8F" stroke-width="4" mask="url(#path-3-inside-2_2984_554)"/>
							<path d="M12.8129 12.2502C12.356 11.7932 11.6136 11.7922 11.1706 12.2626C4.36715 19.4867 0.562744 29.0472 0.562744 39C0.562744 48.9528 4.36715 58.5133 11.1706 65.7374C11.6137 66.2078 12.356 66.2068 12.8129 65.7498C13.2698 65.2929 13.2682 64.5532 12.8261 64.082C6.46095 57.2974 2.90274 48.3321 2.90274 39C2.90274 29.6679 6.46095 20.7026 12.8261 13.918C13.2682 13.4468 13.2698 12.7071 12.8129 12.2502Z" fill="#8CBD8F"/>
							<path d="M67.1936 66.6184C67.6505 67.0753 68.3928 67.0764 68.8358 66.606C75.6393 59.3819 79.4437 49.8213 79.4437 39.8685C79.4437 29.9157 75.6393 20.3552 68.8358 13.1311C68.3928 12.6607 67.6505 12.6618 67.1936 13.1187C66.7367 13.5756 66.7383 14.3153 67.1804 14.7865C73.5455 21.5711 77.1037 30.5364 77.1037 39.8685C77.1037 49.2007 73.5455 58.1659 67.1804 64.9505C66.7383 65.4218 66.7367 66.1615 67.1936 66.6184Z" fill="#8CBD8F"/>
							<path d="M28.9084 44.3132L28.1134 50.548C28.0639 50.9364 28.4598 51.2285 28.8163 51.0665L33.5 48.9375L28.9084 44.3132Z" fill="white"/>
							<circle cx="40.0002" cy="38.7942" r="12.3242" fill="white"/>
							<rect x="34.249" y="33.8645" width="11.5026" height="1.64323" rx="0.821614" fill="#8CBD8F"/>
							<rect x="34.249" y="37.9727" width="11.5026" height="1.64323" rx="0.821614" fill="#8CBD8F"/>
							<rect x="34.249" y="42.0808" width="11.5026" height="1.64323" rx="0.821614" fill="#8CBD8F"/>
						</g>
					</svg>
				</button>
				<div style="display: flex; flex-direction: column; gap: 3px">
					<a class="header__phone" href="tel:+78006003624">8 (800) 600-36-24</a>
				</div>
			</div>
		</div>
	</header>
	<Teleport to="body">
		<Modal :show="showMobileMenu" @close="showMobileMenu = false" class="menu">
			<template #header></template>
			<template #icon></template>
			<template #body>
				<h1 class="menu__headline">Меню</h1>
				<nav class="nav">
					<ul class="nav__list">
						<li class="nav__item" :class="{
							'active': (
								router.currentRoute.value.name === 'home'
								|| router.currentRoute.value.name === 'info-status'
								|| router.currentRoute.value.name === 'main-page'
								|| router.currentRoute.value.name === 'approved'
								|| router.currentRoute.value.name === 'payout-status'
							)
						}">
							<button @click="router.push({name: 'home'})">Главная</button>
						</li>
						<li class="nav__item" :class="{'active': router.currentRoute.value.name === 'archieve'}">
							<button @click="router.push({name: 'archieve'})">История</button>
						</li>
						<li class="nav__item">
							<button class="nav__link" @click="store.dispatch('logOut')">Выйти</button>
						</li>
					</ul>
				</nav>
				<h2 class="menu__headline">Служба заботы о клиентах</h2>
				<div class="contact-us">
					<div class="contact-us__block menu" style="grid-column: 1/-1; flex-direction: column">
						<div style="display: flex; flex-direction: column">
							<a href="tel:+78006003624" class="contact-us__accent">8 (800) 600-36-24</a>
						</div>
						<span class="contact-us__details">горячая линия</span>
					</div>
<!--					<button @click="showMobileMenu = false; showRequestCallModal = true" class="contact-us__block menu">-->
<!--						<span class="contact-us__accent">Заказать звонок</span>-->
<!--						<span class="contact-us__details">с 09:00 до 20:00</span>-->
<!--					</button>-->
					<button class="contact-us__block menu" @click="openChat">
						<span class="contact-us__accent">Написать в чат</span>
					</button>
					<a class="contact-us__block menu" href="https://t.me/IncognitoCR_bot" target="_blank">
						<span class="contact-us__accent">Написать в Телеграм</span>
					</a>
				</div>
<!--				<Button v-if="showInstallPrompt" :handler="installPWA" class="menu__pwa">Скачать приложение Incognito</Button>-->
			</template>
			<template #footer>
<!--				<h2 class="menu__headline socials">Подписывайтесь на наши соцсети</h2>-->
<!--				<ul class="socials__list">-->
<!--					<li class="socials__list-item"><a target="_blank" href="https://vk.com/incognitocredit"><img src="./img/menu-vk.png" alt=""></a></li>-->
<!--					<li class="socials__list-item"><a target="_blank" href="https://ok.ru/group/59751317569554"><img src="./img/menu-ok.png" alt=""></a></li>-->
<!--				</ul>-->
			</template>
		</Modal>
	</Teleport>
	<Teleport to="body">
		<ModalCenter :show="store.state.showContactMethods" @close="store.commit('SET_CONTACT_METHODS', false)" class="contact-methods">
			<template #header></template>
			<template #icon></template>
			<template #body>
				<h1 class="contact-methods__headline">Свяжитесь с Incognito</h1>
				<p>Выберите удобный способ:</p>
				<div class="contact-us contact-us--contact-methods">
					<div class="contact-us__block">
						<div class="contact-us__block-text-wrap">
							<a href="tel:+78006003624" class="contact-us__accent">8 (800) 600-36-24</a>
							<span class="contact-us__details">горячая линия</span>
						</div>
						<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
							<path d="M1.5 9L9.5 1"  stroke-width="2" stroke-linecap="round"/>
							<path d="M1.5 1H9.5"  stroke-width="2" stroke-linecap="round"/>
							<path d="M9.5 9L9.5 1"  stroke-width="2" stroke-linecap="round"/>
						</svg>
					</div>
<!--					<button v-if="store.state.token" @click="store.commit('SET_CONTACT_METHODS', false); showRequestCallModal = true" class="contact-us__block">-->
<!--						<div class="contact-us__block-text-wrap">-->
<!--							<span class="contact-us__accent">Заказать звонок</span>-->
<!--							<span class="contact-us__details">с 09:00 до 20:00</span>-->
<!--						</div>-->
<!--						<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">-->
<!--							<path d="M1.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>-->
<!--							<path d="M1.5 1H9.5" stroke-width="2" stroke-linecap="round"/>-->
<!--							<path d="M9.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>-->
<!--						</svg>-->
<!--					</button>-->
					<button class="contact-us__block" @click="openChat">
						<div class="contact-us__block-text-wrap">
							<span class="contact-us__accent">Написать в чат</span>
						</div>
						<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
							<path d="M1.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>
							<path d="M1.5 1H9.5" stroke-width="2" stroke-linecap="round"/>
							<path d="M9.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>
						</svg>
					</button>
					<a class="contact-us__block" href="https://t.me/IncognitoCR_bot" target="_blank">
						<div class="contact-us__block-text-wrap">
							<span class="contact-us__accent">Написать в Телеграм</span>
						</div>
						<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
							<path d="M1.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>
							<path d="M1.5 1H9.5" stroke-width="2" stroke-linecap="round"/>
							<path d="M9.5 9L9.5 1" stroke-width="2" stroke-linecap="round"/>
						</svg>
					</a>
				</div>
			</template>
			<template #footer></template>
		</ModalCenter>
	</Teleport>
	<Teleport to="body">
		<ModalCenter :show="showRequestCallModal" @close="showRequestCallModal = false" :show-cross-to-close="true" class="request-call">
			<template #header></template>
			<template #icon></template>
			<template #body>
				<h1 class="request-call__headline" v-html="requestCallHeadline"></h1>
				<p class="request-call__details">{{requestCallDetails}}</p>
				<div class="request-call__actions">
					<p v-if="requestCallError" class="request-call__error">{{requestCallError}}</p>
					<Button :isPreloader="true" :handler="requestCall" class="request-call__await button--request-call-await">{{requestCallAwaitBtnText}}</Button>
					<Button @click="showRequestCallModal = false" class="request-call__reject button--request-call-reject">Отменить звонок</Button>
				</div>
			</template>
			<template #footer></template>
		</ModalCenter>
	</Teleport>
</template>

<script setup>
import Modal from '@/shared/components/Modal';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import ModalCenter from '@/shared/components/ModalCenter/ModalCenter.vue';
import Button from '@/shared/components/Button/Button.vue';
import { formatPhone } from '@/shared/lib/helpers/formatters';
// import usePwa from '@/shared/lib/hooks/usePwa';

const store = useStore();
const router = useRouter();

const showMobileMenu = ref(true);
// const showContactMethods = ref(false);
const showRequestCallModal = ref(false);

const userLoggedIn = computed(() => store.state.user);
const isTablet = computed(() => store.state.isTablet.isTablet);
const workTime = computed(() => new Date().getHours() >= 9 && new Date().getHours() < 20);
const requestCallHeadline = computed(() => (workTime.value ? `Заказать обратный звонок <br> на ${formatPhone(store.state.user?.phone.number)}?` : 'К сожалению, в офисе сейчас никого нет:('));
const requestCallDetails = computed(() => (workTime.value ? 'Наш оператор свяжется с Вами в течение пары минут и ответит на все ваши вопросы' : 'Связаться с вами в рабочее время? Мы работаем с 09:00 до 20:00.'));
const requestCallAwaitBtnText = computed(() => (workTime.value ? 'Да, жду звонка' : 'Да, буду ждать звонка'));
const requestCallError = ref(null);
const mainSiteLink = computed(() => (process.env.NODE_ENV === 'development' ? 'http://incognito.beta/' : 'https://incognitocr.ru/'));
const openChat = () => {
	if (window.BXLiveChat) {
		window.BXLiveChat.open();
		store.commit('SET_CONTACT_METHODS', false);
	}
};
// const { showInstallPrompt, installPWA } = usePwa();

watch(() => router.currentRoute.value.name, (newVal, oldValue) => {
	if (newVal !== oldValue) {
		showMobileMenu.value = false;
	}
});

watch([showMobileMenu, () => store.state.showContactMethods, showRequestCallModal], (show) => {
	const [menu, methods, reqCall] = show;
	if (menu || methods || reqCall) {
		document.body.style.overflow = 'hidden';
	} else {
		document.body.style.overflow = 'auto';
	}
});

async function requestCall() {
	try {
		const response = await store.dispatch('requestCall/requestCall');
		console.log('RequestCall response:', response);
		showRequestCallModal.value = false;
	} catch (err) {
		console.log('RequestCall error:', err);
		requestCallError.value = err.data.user_message || err.data.message || `${err.status} ${err.statusText}` || '';
	}
}

</script>

<style lang="scss" scoped>
@import 'header';
</style>
